import { css, keyframes } from "styled-components";
const blink = /*#__PURE__*/keyframes(["from{opacity:1;}to{opacity:0.2;}"]);
const blinkAnimation = /*#__PURE__*/css(["animation:", " 0.3s linear infinite alternate;"], blink);
export default blinkAnimation;
//# sourceMappingURL=blink.js.map